<template>
    <div class="resizable-grids-wrapper">
        <div ref="gridLeft" class="resizable-grids-left">
            <slot name="grid-left"></slot>
        </div>
        <div ref="dragHandler" :class="{'is-dragging': isDragging}" class="resizable-grids-drag-handler"
             @mousedown.stop.prevent="handleHandlerMousedown"></div>
        <div ref="gridRight" class="resizable-grids-right">
            <slot name="grid-right"></slot>
        </div>
    </div>
</template>

<script>
const HANDLER_WIDTH = 9;
export default {
    name: 'resizable-grids',
    props: {
        direction: {
            type: String,
            default: 'horizontal'
        },
        startWidth: {
            type: Number
        },
        startWidthMin: {
            type: Number
        },
        startWidthMax: {
            type: Number
        }
    },
    data() {
        return {
            // 记录 mousedown 事件 的 clientX 值
            mousedownClientX: 0,
            // 记录 mouseup 事件时，鼠标拖动的X轴距离
            lastDeltaX: 0,
            isDragging: false
        };
    },
    mounted() {
        this.$refs.gridLeft.style.width = `${this.startWidth}px`;
        this.$refs.gridRight.style.width = `calc(100% - ${HANDLER_WIDTH}px - ${this.$refs.gridLeft.style.width})`;
    },
    methods: {
        handleHandlerMousedown(e) {
            this.isDragging = true;

            this.mousedownClientX = e.clientX;
            let deltaX = 0;
            document.onmousemove = (ev) => {
                const thisEvent = ev || event;
                deltaX = thisEvent.clientX - this.mousedownClientX;
                const newDeltaX = this.lastDeltaX + deltaX;
                let newStartWidth = this.startWidth + newDeltaX;

                if (newStartWidth > this.startWidthMax) {
                    // 最大宽度
                    deltaX = 0;
                    newStartWidth = this.startWidthMax;
                    this.lastDeltaX = this.startWidthMax - this.startWidth;
                }
                if (newStartWidth < this.startWidthMin) {
                    // 最小宽度
                    deltaX = 0;
                    newStartWidth = this.startWidthMin;
                    this.lastDeltaX = this.startWidthMin - this.startWidth;
                }
                this.$refs.gridLeft.style.width = `${newStartWidth}px`;
                this.$refs.gridRight.style.width = `calc(100% - ${HANDLER_WIDTH}px - ${this.$refs.gridLeft.style.width})`;
            };
            document.onmouseup = () => {
                this.isDragging = false;

                document.onmousemove = null;
                document.onmouseup = null;
                this.lastDeltaX = this.lastDeltaX + deltaX;
            };
        }
    }
};
</script>

<style lang="less" scoped>

.resizable-grids-wrapper {
    display: flex;
    width: 100%;

    .resizable-grids-drag-handler {
        width: 9px;
        height: 100%;
        z-index: 10;
        background: linear-gradient(to right, #fafafa 0, #fafafa 4px, #ebeef5 4px, #ebeef5 5px, #fafafa 5px, #fafafa 100%);
        transition: width 0.1s;
        transition-timing-function: ease;

        &:hover, &.is-dragging {
            cursor: col-resize;
            background: linear-gradient(to right, #fafafa 0, #fafafa 3px, #e3e7ef 3px, #e3e7ef 6px, #fafafa 6px, #fafafa 100%);
        }
    }

    .resizable-grids-left, .resizable-grids-right {
    }
}

</style>
